module.exports = __webpack_public_path__ + "img/close.6dfe3be1.png";